import { UseBaseQueryOptions } from '@tanstack/react-query'
import { useQuery } from '@tanstack/react-query'
import { DashboardKeys } from '@/modules/dashboard/keys'
import {
	GetPlayerDepositWithdrawGraphResponse,
	GetPlayerDepositWithdrawGraphRequest,
} from '@/modules/dashboard/type'
import { getPlayerDepositWithdrawGraph } from '../../services'

export default function useQueryGetPlayerDepositWithdrawGraph(
	payload: GetPlayerDepositWithdrawGraphRequest,
	props?: UseBaseQueryOptions<GetPlayerDepositWithdrawGraphResponse>,
) {
	return useQuery({
		queryKey: [DashboardKeys.PlayerDepositWithdrawGraph, payload],
		queryFn: () => getPlayerDepositWithdrawGraph(payload),
		...props,
	})
}
